import { LoginState, SessionData } from '../types/LogInTypes';
import { isJsonString } from './nullChecks';

export const JSONToken = 'jwt';
export const APP_VERSION = 'AppVersion';
const AUTH = 'auth';
const PRIVILEGES = 'privileges';

export const persistPrivileges = (privileges: Array<string>) => {
    localStorage.setItem(PRIVILEGES, privileges.join(','));
};

const getCookieValue = (name: string) => {
    const appVersionCookie = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    if (!appVersionCookie) {
        return '';
    }
    return appVersionCookie.pop() || '';
};

export const getAppVersion = () => getCookieValue(APP_VERSION);

export const persistLogin = (state: SessionData) => {
    localStorage.setItem(AUTH, JSON.stringify({
        isLoggedIn: true,
        login: state,
    }));
};

export const clearAllDataAndReload = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
};

export const getLoginState = (): LoginState => {
    const storedState = localStorage.getItem(AUTH);
    let loginState;
    if (storedState && isJsonString(storedState)) {
        loginState = JSON.parse(storedState);
    } else {
        loginState = {
            isLoggedIn: false,
            login: null,
        };
    }
    return loginState;
};

export const getLoggedInUserName = () => {
    const state = getLoginState();
    return (state?.login?.fullName);
};

export const getLoggedInUserTitle = () => {
    const state = getLoginState();
    return state?.login?.username;
};

export const getLoggedInUserHasTwoFactorAuthEnabled = () => {
    const state = getLoginState();
    return state?.login?.twoFactorAuthEnabled;
};

export const getPrivileges = () => localStorage.getItem(PRIVILEGES);
